const avatarFormCompany = {
  logo: 'LOGO',
  Typography: 'Espere a que se cargue el archivo'
};

export default avatarFormCompany;
